import moment from "moment";
import high from "../assets/svgs/high-prority.svg";
import low from "../assets/svgs/low-prority.svg";
import medium from "../assets/svgs/medium-prority.svg";
import phone from "../assets/svgs/phone-call.svg";
import none from "../assets/svgs/Remove.svg";
import email from "../assets/svgs/send-email.svg";
import task from "../assets/svgs/task.svg";

export const today = new Date();

export const monthOptions = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "Septemper" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const amPmOptions = [
  { value: "AM", label: "AM" },
  { value: "PM", label: "PM" },
];

export const leadSourceCategoryOptions = [
  { label: "Events", value: "Events" },
  { label: "Marketing", value: "" },
  { label: "Miscellaneous", value: "Miscellaneous" },
  { label: "Prospecting", value: "Prospecting" },
  { label: "Relationships", value: "Relationships" },
];

export const assignTimeOptions = [
  { value: "Any Time", label: "Any Time" },
  { value: "Early Morning (4:00 AM-8:00 AM)", label: "Early Morning (4:00 AM-8:00 AM)" },
  { value: "Morning (8:00 AM-12:00 PM)", label: "Morning (8:00 AM-12:00 PM)" },
  { value: "Afternoon (12:00 PM-4:00 PM)", label: "Afternoon (12:00 PM-4:00 PM)" },
  { value: "Evening (4:00 PM-8:00 PM)", label: "Evening (4:00 PM-8:00 PM)" },
];

export const smartPlanOptions = [
  { value: "email", label: "Email", icon: email },
  { value: "mail", label: "Mail", icon: email },
  { value: "phone", label: "Phone Call", icon: phone },
  { value: "task", label: "Task", icon: task },
];

export const roles = [
  { value: 2, label: "Admin" },
  { value: 3, label: "Sales" },
  { value: 1, label: "Super-Admin" },
];

export const itemPerPageOptions = [
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
  { value: 500, label: "500" },
];

export const phoneOptions = [
  { value: "fax", label: "Fax" },
  { value: "home", label: "Home" },
  { value: "mobile", label: "Mobile" },
  { value: "work", label: "Work" },
  { value: "other", label: "Other" },
];

export const emailOptions = [
  { value: "personal", label: "Personal" },
  { value: "work", label: "Work" },
  { value: "other", label: "Other" },
];

export const addressOptions = [
  { value: "home", label: "Home" },
  { value: "work", label: "Work" },
  { value: "other", label: "Other" },
];

export const linkOptions = [
  { value: "facebook", label: "Facebook" },
  { value: "linkedin", label: "LinkedIn" },
  { value: "google_drive", label: "GoogleDrive" },
  { value: "website", label: "Website" },
];

export const relationshipOptions = [
  { value: "business partner", label: "Business Partner" },
  { value: "child", label: "Child" },
  { value: "employer", label: "Employer" },
  { value: "employee", label: "Employee" },
  { value: "grandparent", label: "Grandparent" },
  { value: "grandchild", label: "Grandchild" },
  { value: "parent", label: "Parent" },
  { value: "sibling", label: "Sibling" },
  { value: "spouse", label: "Spouse" },
  { value: "other", label: "Other" },
];

export const filterTabData = [
  { label: "With", value: "with" },
  { label: "Without", value: "without" },
];

export const dropdownOptions = [
  { label: "admin", value: "admin" },
  { label: "sales", value: "sales" },
];



export const filterThreeTabData = [
  { label: "Date", value: "date" },
  { label: "Within Last", value: "within_last" },
  { label: "Longer Than", value: "longer_than" },
];

export const contactType = [
  { label: "All", value: "all" },
  { label: "Contacts Only", value: "contacts_only" },
  { label: "Leads Only", value: "leads_only" },
];

export const priorityOptions = [
  { label: "None", value: "none", icon: none, color: "#6F6F6F" },
  { label: "Low", value: "low", icon: low, color: "#FFB952" },
  { label: "High", value: "high", icon: high, color: "#FF0000" },
  { label: "Medium", value: "medium", icon: medium, color: "#3761E9" },
];

export const taskRepeatOptions = [
  { value: "does not repeat", label: "Does not repeat" },
  { value: "daily", label: "Daily" },
  {
    value: `weekly on ${moment(today).format("dddd")}`,
    label: `Weekly on ${moment(today).format("dddd")}`,
  },
  {
    value: `monthly on Second ${moment(today).format("dddd")}`,
    label: `Monthly on Second ${moment(today).format("dddd")}`,
  },
  {
    value: `yearly on ${moment(today).format("MMM Do")}`,
    label: `Yearly on ${moment(today).format("MMM Do")}`,
  },
  { value: "custom", label: "Custom" },
];

export const landlordOptions = [
  { value: "Gross", label: "Gross" },
  { value: "Ground", label: "Ground" },
  { value: "Leasehold", label: "Leasehold" },
  { value: "NNN", label: "NNN" },
  { value: "NN", label: "NN" },
  { value: "Roof & Structure", label: "Roof & Structure" },
];

export const activityOptions = [
  { value: "Conversation", label: "Conversation" },
  { value: "Email", label: "Email" },
  { value: "Left Message", label: "Left Message" },
  { value: "Mail", label: "Mail" },
  { value: "Meeting", label: "Meeting" },
  { value: "Note", label: "Note" },
  { value: "Text", label: "Text" },
];


export const selectedOption = [
  { value: "Contact", label: "Contact" },
  { value: "Company", label: "Company" },
  { value: "Property", label: "Property" },
  { value: "Buyer", label: "Buyer" },
  { value: "Pipeline", label: "Pipeline" },
  { value: "Lead", label: "Lead" },
  { value: "Bov", label: "BOV" },
  { value: "Exclusive", label: "Exclusive" },
  { value: "Offer", label: "Offer" },
  { value: "Executed LOI", label: "Executed LOI" },
  { value: "UnderContract", label: "UnderContract" },
  { value: "Closed", label: "Closed" },

];


export const languageOptions = [{ label: "English", value: "english" }];

export const stateOptions = [
  { label: "Nationwide", value: "Nationwide" },
  { label: "AL", value: "AL" },
  { label: "AK", value: "AK" },
  { label: "AZ", value: "AZ" },
  { label: "AR", value: "AR" },
  { label: "AS", value: "AS" },
  { label: "CA", value: "CA" },
  { label: "CO", value: "CO" },
  { label: "CT", value: "CT" },
  { label: "DE", value: "DE" },
  { label: "DC", value: "DC" },
  { label: "FL", value: "FL" },
  { label: "GA", value: "GA" },
  { label: "GU", value: "GU" },
  { label: "HI", value: "HI" },
  { label: "ID", value: "ID" },
  { label: "IL", value: "IL" },
  { label: "IN", value: "IN" },
  { label: "IA", value: "IA" },
  { label: "KS", value: "KS" },
  { label: "KY", value: "KY" },
  { label: "LA", value: "LA" },
  { label: "ME", value: "ME" },
  { label: "MD", value: "MD" },
  { label: "MA", value: "MA" },
  { label: "MI", value: "MI" },
  { label: "MN", value: "MN" },
  { label: "MS", value: "MS" },
  { label: "MO", value: "MO" },
  { label: "MT", value: "MT" },
  { label: "NE", value: "NE" },
  { label: "NV", value: "NV" },
  { label: "NH", value: "NH" },
  { label: "NJ", value: "NJ" },
  { label: "NM", value: "NM" },
  { label: "NY", value: "NY" },
  { label: "NC", value: "NC" },
  { label: "ND", value: "ND" },
  { label: "MP", value: "MP" },
  { label: "OH", value: "OH" },
  { label: "OK", value: "OK" },
  { label: "OR", value: "OR" },
  { label: "PA", value: "PA" },
  { label: "PR", value: "PR" },
  { label: "RI", value: "RI" },
  { label: "SC", value: "SC" },
  { label: "SD", value: "SD" },
  { label: "TN", value: "TN" },
  { label: "TX", value: "TX" },
  { label: "TT", value: "TT" },
  { label: "UT", value: "UT" },
  { label: "VT", value: "VT" },
  { label: "VA", value: "VA" },
  { label: "VI", value: "VI" },
  { label: "WA", value: "WA" },
  { label: "WV", value: "WV" },
  { label: "WI", value: "WI" },
  { label: "WY", value: "WY" },
];

export const stateFullNameOptions = [
  { label: "Nationwide", value: "Nationwide" },
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "American Samoa", value: "AS" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "District of Columbia", value: "DC" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Guam", value: "GU" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Northern Mariana Islands", value: "MP" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Trust Territories", value: "TT" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Virgin Islands", value: "VI" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];
